// extracted by mini-css-extract-plugin
export default {"head_item":"styles_head_item__fs0-+","search":"styles_search__NjwRl","search_inp":"styles_search_inp__vFbk9"};